export enum InterfaceType {
  LIFF = 'LIFF',
  TALARIA = 'TALARIA',
  UNKNOWN = 'UNKNOWN',
}

export const getInterfaceType = () => {
  if (window._liff) {
    return InterfaceType.LIFF;
  } else if (window._Talaria) {
    return InterfaceType.TALARIA;
  } else {
    return InterfaceType.UNKNOWN;
  }
};

export const isTalaria = () => {
  return getInterfaceType() === InterfaceType.TALARIA;
};

export const isLIFF = () => {
  return getInterfaceType() === InterfaceType.LIFF;
};

export const isClient = () => typeof window !== 'undefined';
